import { calculatePaginationOffset, compareValues, convertSortToQueryString, } from "@sscs/utils";
import { REPORTS_ENDPOINT } from "../../constants";
import { baseApi } from "./base.api.required.stub";
const signaturesApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getSignatures: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.ui_id}/signatures`,
                params: {
                    policy_id: data.filter.policy_id,
                    identity: data.filter.identity,
                    only_violations: data.filter.only_violations,
                    sort_by: convertSortToQueryString(data.sort),
                    limit: data.pagination.itemsPerPage,
                    offset: calculatePaginationOffset(data.pagination),
                },
            }),
        }),
        getSignatureSources: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.ui_id}/signatures/${data.ui_item_id}/components`,
                params: data,
            }),
        }),
        getSignaturePolicies: build.query({
            query: (queryArg) => ({
                url: `${REPORTS_ENDPOINT}/${queryArg.ui_id}/signatures/policies`,
            }),
            transformResponse: (queryArg) => {
                return queryArg.sort((first, second) => compareValues(first.id, second.id, false));
            },
        }),
    }),
    overrideExisting: false,
});
export const { useGetSignaturesQuery, useGetSignatureSourcesQuery, useLazyGetSignaturePoliciesQuery, } = signaturesApi;
//# sourceMappingURL=signatures.api.js.map